import { render, staticRenderFns } from "./MyConnectionsList.vue?vue&type=template&id=df9bbeca"
import script from "./MyConnectionsList.vue?vue&type=script&lang=js"
export * from "./MyConnectionsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports